var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select"},[_c('el-cascader',{attrs:{"options":_vm.options},on:{"change":_vm.handleChange},model:{value:(_vm.selectedOptions),callback:function ($$v) {_vm.selectedOptions=$$v},expression:"selectedOptions"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }